export const SET_TRENDINGBLOGS_BLOG_STATE = 'SET_TRENDINGBLOGS_BLOG_STATE';
export const SET_SOCIALBLOGS_BlOG_STATE = 'SET_SOCIALBLOGS_BlOG_STATE';
export const SET_AIGENERATEDBLOGS_POST_STATE = 'SET_AIGENERATEDBLOGS_POST_STATE';
export const SET_YOUTUBE_BlOG_STATE = 'SET_YOUTUBE_BlOG_STATE';
export const SET_YOUTUBE_TITLEANDCHAPTERS_STATE = 'SET_YOUTUBE_TITLEANDCHAPTERS_STATE';

